module.exports = __webpack_public_path__ + "static/UnclickOthersYellow-5436f7f54fbf37bf68ef1f3352a7654d.png";